import convertKeys from 'utils/convert-keys'
import { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'

const ENDPOINT = '/v2/transactions'

const fetchTransactions = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(`${ENDPOINT}/`)

  return convertKeys.toCamel(response.data)
}

const claimPendingTransactions = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ENDPOINT}/claim`)
  return convertKeys.toCamel(data)
}

export default {
  fetchTransactions,
  claimPendingTransactions,
}
